// DS: UI11
import React, { useCallback } from 'react';
import Flex from '@wix/da-ds/pkg/Flex';
import LinkArrowIcon from '@wix/da-ds/pkg/Icons/LinkArrow';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './ViewReplies.scss';
// If it will be reused please extract it into its own component.
var ViewReplies = function (_a) {
    var className = _a.className, children = _a.children, onClick = _a.onClick;
    var clickHandler = useCallback(function (e) { return onClick(); }, [onClick]);
    return (React.createElement(Flex, { className: s['root'], alignItems: "center", onClick: clickHandler },
        React.createElement(LinkArrowIcon, { className: s['icon'], size: IconSize.MEDIUM }),
        React.createElement("span", { className: s['text'] }, children)));
};
ViewReplies.displayName = 'ViewReplies';
export default ViewReplies;
//# sourceMappingURL=ViewReplies.js.map